﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import config from '../../../common/config';


import tpl_searchEventListItemDetails from './tpl/searchEventListItemDetails.html';
import View_DialogPreviewWebpage from '../../../portal/views/dialogPreview/dialogPreviewWebpage';
import * as Entities_Empty from '../../../lib/entities/empty';

export default Marionette.ItemView.extend({
    initialize: function () {
        this.app = this.options.app;

        var localStartDate = new Date(this.model.attributes.UtcStartDate);
        var strStartDate = localStartDate.getDate().toString() + '/' + (localStartDate.getMonth() + 1) + '/' + localStartDate.getFullYear().toString();

        var localEndDate = new Date(this.model.attributes.UtcEndDate);
        var strEndDate = localEndDate.getDate().toString() + '/' + (localEndDate.getMonth() + 1) + '/' + localEndDate.getFullYear().toString();

        this.model.attributes.strStartDate = strStartDate;
        this.model.attributes.strEndDate = strEndDate;
    },
    getTemplate: function () {
        return tpl_searchEventListItemDetails({ model: this.model.toJSON() });
    },
    ui: {
        'searchEventListItemDetails_btnBack': '#searchEventListItemDetails_btnBack',
        'searchEventListItemDetails_webpageEvent' : '#searchEventListItemDetails_webpageEvent',
        'searchEventListItemDetails_webpageEventPreview' : '#searchEventListItemDetails_webpageEventPreview',
        'searchEventListItemDetails_webpageEventSchemaScreen' : '#searchEventListItemDetails_webpageEventSchemaScreen',
        'searchEventListItemDetails_webpageEventInfoScreen' : '#searchEventListItemDetails_webpageEventInfoScreen',
        'searchEventListItemDetails_webpageEventPoster' : '#searchEventListItemDetails_webpageEventPoster',
        'searchEventListItemDetails_div_webpageEventSchemaScreen' : '#searchEventListItemDetails_div_webpageEventSchemaScreen',
        'searchEventListItemDetails_div_webpageEventInfoScreen' : '#searchEventListItemDetails_div_webpageEventInfoScreen',
        'searchEventListItemDetails_div_webpageEventPoster' : '#searchEventListItemDetails_div_webpageEventPoster'
    },
    events: {
        'click @ui.searchEventListItemDetails_btnBack': 'back',
        'click @ui.searchEventListItemDetails_webpageEvent': 'webpageEvent',
        'click @ui.searchEventListItemDetails_webpageEventPreview': 'webpageEventPreview',
        'click @ui.searchEventListItemDetails_webpageEventSchemaScreen': 'webpageEventSchemaScreen',
        'click @ui.searchEventListItemDetails_webpageEventInfoScreen': 'webpageEventInfoScreen',
        'click @ui.searchEventListItemDetails_webpageEventPoster': 'webpageEventPoster'
    },
    onRender: function () {
        this.setupUrl()
    },
    setupUrl: function () {
        //var friendlyUrl = this.model.attributes.id;
        //if (this.model.attributes.FriendlyUrl && this.model.attributes.FriendlyUrl.length > 0) {
        //    friendlyUrl = this.model.attributes.FriendlyUrl;
        //}

        //var webpageEvent = config.webApiUrl() + '/events/' + friendlyUrl;
        //var webpageInfo = config.webApiUrl() + '/events/' + friendlyUrl + '#' + resources.X100140;
        //var webpagePoster = config.webApiUrl() + '/events/' + friendlyUrl + '#' + resources.X100141;
        //var webpageSchemaBigscreen = config.webApiUrl() + '/events/' + friendlyUrl + '#' + resources.X100419;

        //this.ui.searchEventListItemDetails_webpageEvent.attr('href', webpageEvent);
        //this.ui.searchEventListItemDetails_webpageInfo.attr('href', webpageInfo);
        //this.ui.searchEventListItemDetails_webpagePoster.attr('href', webpagePoster);
        //this.ui.searchEventListItemDetails_webpageSchemaBigscreen.attr('href', webpageSchemaBigscreen);

        //if (this.model.attributes.ShowInfo == false) {
        //    this.ui.customEventEditItem_webpageInfo.css('display', 'none');
        //}

        //if (this.model.attributes.ShowPoster == false) {
        //    this.ui.customEventEditItem_webpagePoster.css('display', 'none');
        //}

        //if (this.model.attributes.ShowSchema == false) {
        //    this.ui.searchEventListItemDetails_webpageSchemaBigscreen.css('display', 'none');
        //}

        if (this.model.attributes.Webpage > 0 && this.model.attributes.SchemaModel > 0) {
            //this.ui.searchEventListItemDetails_webpageEventSchemaScreen.prop('disabled', false);
            //this.ui.searchEventListItemDetails_webpageEventSchemaScreen.addClass('btn-secondary');
            //this.ui.searchEventListItemDetails_webpageEventSchemaScreen.removeClass('btn-disabled');
            this.ui.searchEventListItemDetails_div_webpageEventSchemaScreen.show();
        } else {
            //this.ui.searchEventListItemDetails_webpageEventSchemaScreen.prop('disabled', true);
            //this.ui.searchEventListItemDetails_webpageEventSchemaScreen.removeClass('btn-secondary');
            //this.ui.searchEventListItemDetails_webpageEventSchemaScreen.addClass('btn-disabled');
            this.ui.searchEventListItemDetails_div_webpageEventSchemaScreen.css('display','none');
        }

        if (this.model.attributes.Webpage > 0 && this.model.attributes.Infopage > 0) {
            /*this.ui.searchEventListItemDetails_webpageEventInfoScreen.prop('disabled', false);
            this.ui.searchEventListItemDetails_webpageEventInfoScreen.addClass('btn-secondary');
            this.ui.searchEventListItemDetails_webpageEventInfoScreen.removeClass('btn-disabled');*/
            this.ui.searchEventListItemDetails_div_webpageEventInfoScreen.show();

        } else {
            /*this.ui.searchEventListItemDetails_webpageEventInfoScreen.prop('disabled', true);
            this.ui.searchEventListItemDetails_webpageEventInfoScreen.removeClass('btn-secondary');
            this.ui.searchEventListItemDetails_webpageEventInfoScreen.addClass('btn-disabled');*/
            this.ui.searchEventListItemDetails_div_webpageEventInfoScreen.css('display','none');
        }
    
        if (this.model.attributes.Webpage > 0 && this.options.poster) {
            //this.ui.searchEventListItemDetails_webpageEventPoster.prop('disabled', false);
            //this.ui.searchEventListItemDetails_webpageEventPoster.addClass('btn-secondary');
            //this.ui.searchEventListItemDetails_webpageEventPoster.removeClass('btn-disabled');
            this.ui.searchEventListItemDetails_div_webpageEventPoster.show();
        } else {
            //this.ui.searchEventListItemDetails_webpageEventPoster.prop('disabled', true);
            //this.ui.searchEventListItemDetails_webpageEventPoster.removeClass('btn-secondary');
            //this.ui.searchEventListItemDetails_webpageEventPoster.addClass('btn-disabled');
            this.ui.searchEventListItemDetails_div_webpageEventPoster.css('display','none');
        }
    },
    back: function (event) {
        //window.history.back();
        this.app.router.navigate('#searchEvent');
        this.app.router.searchEvent();
    },
    webpageEvent: function (event) {
        var friendlyUrl = this.model.attributes.id;
        if (this.model.attributes.FriendlyUrl && this.model.attributes.FriendlyUrl.length > 0) {
            friendlyUrl = this.model.attributes.FriendlyUrl;
        }
                        
        var webpageEvent = config.webApiUrl() + '/events/' + friendlyUrl;
                        
        //window.open(webpageEvent, '_blank', 'fullWindow=yes, scrollbars=yes, width=' + window.outerWidth + ', height=' + window.outerHeight);
        window.open(webpageEvent);
    },
    webpageEventPreview: function (event) {
        var friendlyUrl = this.model.attributes.id;
        if (this.model.attributes.FriendlyUrl && this.model.attributes.FriendlyUrl.length > 0) {
            friendlyUrl = this.model.attributes.FriendlyUrl;
        }
                        
        var webpageEvent = config.webApiUrl() + '/events/' + friendlyUrl;

        var dialogPreviewWebpageModel = new Entities_Empty.Model();
        dialogPreviewWebpageModel.attributes.Title = resources.X100276;
        dialogPreviewWebpageModel.attributes.Iframe = webpageEvent;
        dialogPreviewWebpageModel.attributes.Button = resources.X100279;

        var dialogPreviewWebpage = new View_DialogPreviewWebpage({ model: dialogPreviewWebpageModel, parent: this });
        var callback_dialogPreviewWebpage = function (options) {
            this.stopListening(dialogPreviewWebpage, "dialog:okclicked", callback_dialogPreviewWebpage);
        }
        this.listenTo(dialogPreviewWebpage, "dialog:okclicked", callback_dialogPreviewWebpage);
        this.app.dialogRegion.show(dialogPreviewWebpage);
    },
    webpageEventSchemaScreen: function (event) {
        var friendlyUrl = this.model.attributes.id;
        if (this.model.attributes.FriendlyUrl && this.model.attributes.FriendlyUrl.length > 0) {
            friendlyUrl = this.model.attributes.FriendlyUrl;
        }
                        
        var webpageSchemaBigscreen= config.webApiUrl() + '/events/' + friendlyUrl + '#' + resources.X100419.toLowerCase();
        //window.open(webpageInfo, '_blank', 'fullWindow=yes, scrollbars=yes, width=' + window.outerWidth + ', height=' + window.outerHeight);
        window.open(webpageSchemaBigscreen);
    },
    webpageEventInfoScreen: function (event) {
        var friendlyUrl = this.model.attributes.id;
        if (this.model.attributes.FriendlyUrl && this.model.attributes.FriendlyUrl.length > 0) {
            friendlyUrl = this.model.attributes.FriendlyUrl;
        }
                        
        var webpageInfo = config.webApiUrl() + '/events/' + friendlyUrl + '#' + resources.X100454.toLowerCase();
        //window.open(webpageInfo, '_blank', 'fullWindow=yes, scrollbars=yes, width=' + window.outerWidth + ', height=' + window.outerHeight);
        window.open(webpageInfo);
    },
    webpageEventPoster: function (event) {
        var friendlyUrl = this.model.attributes.id;
        if (this.model.attributes.FriendlyUrl && this.model.attributes.FriendlyUrl.length > 0) {
            friendlyUrl = this.model.attributes.FriendlyUrl;
        }
                        
        var webpagePoster = config.webApiUrl() + '/events/' + friendlyUrl + '#' + resources.X100141.toLowerCase();
        //window.open(webpagePoster , '_blank', 'fullWindow=yes, scrollbars=yes, width=' + window.outerWidth + ', height=' + window.outerHeight);
        window.open(webpagePoster);
    }

});
